module.exports = __webpack_public_path__ + "static/media/mercadopago-logo.028fc6fa.png";